import { WORKLOAD_SERVICES } from '@/components/common/WorkloadQuotaCard'
import type { SibServiceCode } from './useSibCapacityOverview'

/**
 * Series colour per service, from the chart palettes (palettes.ts reserves purple, teal, cyan and
 * pink for charts). Validated with the dataviz palette checks on the light surface: teal at the
 * `solid` step sits too close to cyan, so TOJ uses teal's lighter `focusRing` step. Colour follows
 * the service, never its position, so filtering never repaints a line.
 */
export const SERVICE_COLOR: Record<SibServiceCode, string> = {
  // toCssVar() does not dash-case camelCase token names, so this one is given as its CSS variable.
  TOJ: 'var(--chakra-colors-teal-focus-ring)',
  CONSULTING: 'cyan.solid',
  TRAINING: 'purple.solid',
  PILOT: 'pink.solid',
}

export const serviceLabel = (code: SibServiceCode) =>
  WORKLOAD_SERVICES.find(s => s.key === code)?.label ?? code
